import React from "react";

const HomeDesc = () => {
  return (
    <div className="home-page__main--description">
      <p>
        Не следует, однако забывать, что укрепление и развитие структуры
        представляет
      </p>
    </div>
  );
};

export default HomeDesc;
